import styles from './border-gap.module.css';
import { BorderGapProps } from './border-gap.props';

export const BorderGap = ({ type }: BorderGapProps) => {
	if (type === 'front') {
		return (
			<div className={styles.wrapper}>
				<div className={styles.top} />
				<div className={styles.bottom} />
			</div>
		);
	}

	return <div className={styles.circle} />;
};
